import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const CheckmarkIcon = ({
  width = 24,
  height = 24,
  stroke = '#007EFF',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M20 6L9 17l-5-5"
    />
  </svg>
);
